import { satisfies } from "semver";

import useGetCurrentClusterComponentVersions from "./use-get-current-cluster-component-versions";

function useCurrentClusterSupportsSsh(): boolean {
  return useGetCurrentClusterComponentVersions("ssh").some((v) =>
    satisfies(v, ">=0.1.0"),
  );
}
export default useCurrentClusterSupportsSsh;
